import axios from "../utils/axios";

export const getBreakdownReasonGroupList = () => {
    return axios.get(`/BreakdownReasonGroup/GetList`);
};

export const getBreakdownEffectList = () => {
    return axios.get(`/BreakdownEffect/GetList`);
};

export const getAreaList = () => {
    return axios.get(`/Area/GetList`);
};

export const getEquipmentGetMainListByAreaID = (id) => {
    return axios.get(`/Equipment/GetMainListByAreaID?areaId=${id}`);
};

export const getEquipmentGetSubListById = (id) => {
    return axios.get(`/Equipment/GetSubListById?equipmentId=${id}`);
};

export const getPoolList = () => {
    return axios.get(`/Pool/GetList`);
};

export const getBreakdownReasonPlaceGetListByGroupId = (id) => {
    return axios.get(`/BreakdownReasonPlace/GetListByGroupId?breakdownGroupId=${id}`);
};

export const postUnplannedMaintenanceCreateWithFile = (data) => {
    return axios.post(`/UnplannedMaintenance/CreateWithFile`, data);
};

export const getEquipmentGetByBarcodeContext = (data) => {
    return axios.get(`/Equipment/GetByBarcodeContext?barcodeContext=${data}`);
};
